import * as React from "react";
import { Alert } from "components/bootstrap";
const NoEntitiesExist = ({ children = "No entities exist." }) => /* @__PURE__ */ React.createElement(Alert, { className: "no-bm" }, children);
export default NoEntitiesExist;
